export default __webpack_public_path__ + "static/media/fruity.6aa66531.png";